var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header-layout',[_c('div',{staticClass:"main-page-content"},[(_vm.searchCondition.dept_id)?_c('McnBonusView',{staticClass:"w-full",attrs:{"condition":_vm.searchCondition},on:{"update:condition":function($event){_vm.searchCondition=$event}}}):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }